import React from 'react';
import { InlineWidget } from 'react-calendly';
import { CalendlyWidgetProps } from '../types/components';
import '../styles/styles.css';

const CalendlyWidget: React.FC<CalendlyWidgetProps> = ({ url = 'https://calendly.com/bobbieshrivastav/solvraysdemo?back=1&month=2025-01' }) => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-400">
            Book a Demo
          </h2>
          <p className="text-xl text-gray-400">
            Schedule a time to see Solvrays in action
          </p>
        </div>
        <div className="calendly-inline-widget max-w-5xl mx-auto rounded-lg overflow-hidden">
          <InlineWidget
            url={url}
            styles={{
              height: '650px',
              width: '100%',
            }}
            pageSettings={{
              backgroundColor: '000000',
              hideEventTypeDetails: false,
              hideLandingPageDetails: false,
              primaryColor: '86E2FC',
              textColor: 'ffffff',
            }}
            utm={{
              utmCampaign: 'SpringSale',
              utmContent: 'widget',
              utmMedium: 'referral',
              utmSource: 'ReactApp',
              utmTerm: 'calendly',
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default CalendlyWidget;
